module.exports = __webpack_public_path__ + "media/MargueriteHarperScottQuote.165e32cc.mp3";